
























































































































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import _ from "lodash";
import HealthcareExpenseNavigationV2 from "@/employee/components/healthcareExpenseV2/HealthcareExpenseNavigationV2.vue";
import HealthcareExpensesAdd from "@/employee/components/healthcareExpenseV2/HealthcareExpensesAdd.vue";
import BottomNotification from "@/shared/components/BottomNotification.vue";
import ReimburseMePopup from "@/employee/components/shared/ReimburseMePopup.vue";
import SideBar from "@/employee/components/healthcareExpenseV2/SideBar.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import {
  ReimbursementRequest,
  ExpenseEligibilityGroup,
  PossibleExpense,
  ExpenseEligibility,
  ExpenseRequest
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency";
import ExpensesList from "@/employee/components/healthcareExpenseV2/ExpensesList.vue";
import Button from "@/shared/components/ui/Button.vue";
import Widget from "@/shared/components/Widget.vue";
import TabFilter from "@bend-financial/styleguide";
import { useExpenseV2Store } from "@/employee/store/expenseV2";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useReimburseMeStore } from "@/employee/store/reimburseMe";

@Component({
  components: {
    HealthcareExpenseNavigationV2,
    HealthcareExpensesAdd,
    Widget,
    Button,
    BottomNotification,
    ReimburseMePopup,
    SideBar,
    Pagination,
    ExpensesList,
  },
})
export default class FindExpenses extends Vue {
  expenseStore = useExpenseV2Store();
  bankAccountStore = useBankAccountStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  custodianSettingsStore = useCustodianSettingsStore();
  reimburseMeStore = useReimburseMeStore();

  showReimbursePopup = false;
  showExpenseAddView = false;
  formatCurrency = formatCurrency;
  ExpenseEligibilityGroup = ExpenseEligibilityGroup;
  selectedFilters: TabFilter[] = null;
  possibleExpenses: PossibleExpense[] = [];

  @Prop() routeToSettings;

  mounted () {
    this.expenseBalanceSummaryStore.loadState();
    this.expenseStore.getImportedExpenses();
    this.expenseStore.loadExpenses(this.expenseRequestModel(1, false));
    this.bankAccountStore.loadBankAccountState();
    this.$on("filtersUpdated", this.filtersUpdated);
    this.$on("close-add-expense", event => {
      this.showExpenseAddView = false;
    });
    setTimeout(() => {
      // this.showAdvisorNotification("You've saved <b>$248.00</b> in tax this year!");
    }, 5000);
  }

  created () {
    this.selectedFilters = this.filterOptions.filter(x => x.isEnabled);
  }

  bankNameToClass (name) {
    if (!name) return "";
    return name.toLowerCase().split(" ").join("");
  }

  shortenBankCardNumber (length, cardNumber) {
    if (cardNumber.length > length) {
      return cardNumber.slice(cardNumber.length - length, cardNumber.length);
    } else {
      return cardNumber;
    }
  }

  get filterOptions (): TabFilter[] {
    return [
      {
        title: "Very Likely",
        subtitle: formatCurrency(this.expenseBalanceSummaryStore.likelyEligibleBalance),
        key: ExpenseEligibilityGroup[ExpenseEligibilityGroup.LikelyEligible],
        isEnabled: true,
      },
      {
        title: "Potential",
        subtitle: formatCurrency(this.expenseBalanceSummaryStore.potentiallyEligibleBalance),
        key: ExpenseEligibilityGroup[ExpenseEligibilityGroup.PotentialEligible],
        isEnabled: true,
      },
      {
        title: "Unlikely",
        key: ExpenseEligibilityGroup[ExpenseEligibilityGroup.UnlikelyEligible],
        isEnabled: false
      },
      {
        title: "Ineligible",
        key: ExpenseEligibility[ExpenseEligibility.Ineligible],
        isEnabled: false,
      },
    ];
  }

  filtersUpdated (value: TabFilter[]) {
    this.selectedFilters = value;
    this.filterOptions.forEach(x => {
      x.isEnabled = value.some(t => t.key === x.key);
    });
    this.expenseStore.loadExpenses(this.expenseRequestModel(1, true));
  }

  expenseRequestModel (pageNumber: number, reload: boolean) {
    const expenseEligibilityGroups: ExpenseEligibilityGroup[] = [];

    _.forEach(this.selectedFilters, f => {
      if (f.key as keyof typeof ExpenseEligibilityGroup) {
        expenseEligibilityGroups.push(f.key);
      }
    });

    let eligibleStatus = ExpenseEligibility.None;
    if (_.some(this.selectedFilters, x => x.key === ExpenseEligibility[ExpenseEligibility.Ineligible])) {
      eligibleStatus = ExpenseEligibility.Ineligible;
    } else {
      eligibleStatus = ExpenseEligibility.None;
    }
    const request: ExpenseRequest = {
      pageSize: 10,
      pageNumber: pageNumber ? pageNumber : 1,
      groups: expenseEligibilityGroups,
      expiryPage: reload,
      eligibilityStatus: eligibleStatus
    };
    return request;
  }

  get eligibleBalance () {
    let balance = 0;
    _.forEach(this.selectedFilters, f => {
      // Displaying totals for likely eligible and potential expenses only
      if (f.key === ExpenseEligibilityGroup[ExpenseEligibilityGroup.LikelyEligible]) {
        balance += this.expenseBalanceSummaryStore.likelyEligibleBalance;
      }
      if (f.key === ExpenseEligibilityGroup[ExpenseEligibilityGroup.PotentialEligible]) {
        balance += this.expenseBalanceSummaryStore.potentiallyEligibleBalance;
      }
    });
    return balance;
  }

  get pageButtonsStartValue () {
    return this.expenseStore.expensesPage - 2 > 0 ? this.expenseStore.expensesPage - 2 : 1;
  }

  get pageButtonRange () {
    const endValue = this.expenseStore.expensesPage + 3 < this.expenseStore.expensesPageCount ?
        (this.expenseStore.expensesPage + 3) : (this.expenseStore.expensesPageCount + 1);
    return _.range(this.pageButtonsStartValue, endValue);
  }

  switchPage (pageNumber): void {
    this.expenseStore.loadExpenses(this.expenseRequestModel(pageNumber, false));
  }

  get displayPilotExpenseTracker () {
    return this.expenseStore.importedExpenses.length > 0;
  }

  get hasLinkedCards () {
    return this.bankAccountStore.linkedCards.length > 0;
  }

  get displayLinkCardSection () {
    return this.bankAccountStore.linkedCards.length === 0 && !this.bankAccountStore.linkedCardViewIsLoading;
  }

  get bottomNotificationButtonText (): string {
    return this.custodianSettingsStore.allowReimbursement ? "Reimburse Me" : "Save";
  }

  addExpenseAction (event: any) {
    event.preventDefault();
    this.showExpenseAddView = !this.showExpenseAddView;
  }

  handleNotificationClick (): void {
    if (this.custodianSettingsStore.allowReimbursement) {
      this.showReimbursePopup = true;
    } else {
      const params: ReimbursementRequest = {
        amount: this.reimburseAmount,
        reimbursementLinkedAccountId: 0,
        expenseIds: this.reimburseExpenseIds,
      };
      this.reimburseMeStore.manualMarkedAsReimbursed(params);
    }
  }

  handleNotificationClose () {
    this.expenseBalanceSummaryStore.reimburseMeDismiss();
  }

  closeAll () {
    this.showReimbursePopup = false;
    this.expenseBalanceSummaryStore.reimburseMeDismiss();
  }

  get reimburseAmount () {
    return this.expenseBalanceSummaryStore.reimburseMeAmount.amount;
  }

  get reimburseExpenseIds () {
    return this.expenseBalanceSummaryStore.reimburseMeAmount.expenseIds;
  }

}
